import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import InvitationTableRow from './InvitationTableRow';
import { invitationsActions } from './actions';
import { invitationsSelectors } from './reducer';
import { useDispatchWithProgress } from '../../hooks/useDispatchWithProgress';

const InvitationsTableRows = () => {
  const dispatch = useDispatch();

  const activeReview = useSelector(invitationsSelectors.activeReview);
  const invitations = useSelector(invitationsSelectors.invitationsFilteredAndSorted);
  const selectedAccountNumber = useSelector(state => state.user.get('userAccount')?.number);
  const selectedInvitationId = useSelector(invitationsSelectors.selectedInvitationId);

  const getInvitations = useDispatchWithProgress(invitationsActions.getInvitations);

  useEffect(() => {
    if (activeReview) {
      getInvitations(selectedAccountNumber);
    }

    return () => {
      dispatch({ type: invitationsActions.resetInvitations.name });
    };
  }, [activeReview, selectedAccountNumber]);

  return (
    activeReview &&
    invitations.map(invitation => (
      <InvitationTableRow
        key={invitation.id}
        invitation={invitation}
        {...(invitation.id === selectedInvitationId && { invitationIsSelected: selectedInvitationId })}
      />
    ))
  );
};

export default InvitationsTableRows;
